<script>
import bread from '@/components/bread'
export default {
  name: 'Gene_Editing',
  components: { bread },
  data() {
    return {
      currentType: -1,
      types: [
        {name: '慢病毒包装', img: 'gene_editing_service_1.png', ref: '/Virus/Lentivirus_packaging'},
        {name: 'sgRNA', img: 'gene_editing_service_6.png', ref: '/products/sgRNA_Synthesis'},
        {name: '质粒构建', img: 'gene_editing_service_3.png', ref: '', size: {width: '100%'}},
        {name: '文库构建', img: 'gene_editing_service_4.png', ref: '/products/sgRNA_library_construction'},
        {name: 'ssDNA', img: 'gene_editing_service_2.png', ref: '/products/ssDNA_page'}
      ]
    }
  },
  methods: {
    jumpPage(page) {
      if (page && page !== '') {
        const aLink = document.createElement('a')
        aLink.href = page
        aLink.target = '_blank'
        aLink.click()
      }
    }
  }
}
</script>

<template>
  <div class="wrap wrap-tec">
    <div class="banner">
      <img src="@/assets/img/产品及服务/基因编辑/banner.png" class="img-fluid">
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;">
      <bread></bread>
    </div>
    <section class="container">
      <div class="texture-body">
        <p>
          基因编辑是指通过特定工具在生物基因组中插入、删除或替换DNA片段，从而改变基因功能。基因编辑技术在医学、农业和基础科研领域中有着广泛应用，尤其是CRISPR-Cas9技术，作为目前常用的基因编辑工具，已经在遗传疾病治疗、基因功能研究、农业改良等方面发挥了重要作用。CRISPR-Cas9系统的优势在于其精准性和高效性，为现代基因组学提供了强有力的技术支持。
        </p>
        <p>	常见的基因编辑实现方式：</p>
        <p>
          <span class="highLightTexture">敲除质粒（sgRNA质粒）：</span>在CRISPR-Cas9系统中，sgRNA是引导Cas9精准识别并切割目标DNA位点的核心分子，它由约20个核苷酸的靶向序列和与Cas9结合的恒定序列组成，前者负责定位特定DNA位点，后者与Cas9结合。Cas9在sgRNA引导下对靶基因进行双链断裂，激活细胞的修复机制，从而实现基因敲除或编辑。根据实验需求，sgRNA和Cas9可以选择构建在同一个质粒载体上，简化转染步骤并确保协调表达；也可以分置在两个载体上，提供灵活的表达调控和多重基因编辑的可能性。
        </p>
        <P>
          擎科生物提供的单质粒和双质粒体系，既可以通过电转或化学转染直接导入细胞，也可进行慢病毒包装，通过病毒转染进入细胞。
        </P>
        <p>
          <span class="highLightTexture">敲除（CRISPR）慢病毒包装：</span>慢病毒是基因编辑的一种载体系统，通过慢病毒载体将CRISPR-Cas9和sgRNA系统导入细胞中，从而实现基因的永久敲除或修饰。慢病毒载体的优势在于可以有效转染难以转染的细胞类型，并能够在长期细胞培养中维持稳定的基因表达。并且通过慢病毒载体的帮助，在基因组编辑过程中可以提高效率并降低脱靶风险，广泛应用于多种类型的基因编辑实验。
        </p>
        <p>
          <span class="highLightTexture">sgRNA Oligo：</span>常规sgRNA以质粒或病毒形式递送至细胞，但质粒由于分子量过大，转导效率较低，而病毒载体则存在较高的脱靶和潜在致癌风险。相比之下，使用合成的sgRNA oligo能够有效避免这些问题。通过合成的sgRNA oligo，可精确引导CRISPR-Cas9切割靶DNA，非常高效的触发基因敲除或插入等基因编辑事件。
        </p>
        <p>
          擎科生物采用化学合成技术直接合成全长sgRNA，具有类似siRNA的高效转染效果，并且脱靶率更低，提升了基因编辑的安全性和精准度。
        </p>
        <table class="service-details-table" cellpadding="0" cellspacing="0">
          <tr>
            <th></th>
            <th>化学合成sgRNA</th>
            <th>体外转录sgRNA</th>
            <th>质粒sgRNA</th>
          </tr>
          <tr>
            <td>成本</td>
            <td>较低</td>
            <td>高</td>
            <td>较低</td>
          </tr>
          <tr>
            <td>细胞毒性</td>
            <td>低</td>
            <td>高</td>
            <td>高</td>
          </tr>
          <tr>
            <td>编辑效率</td>
            <td>高</td>
            <td>不稳定</td>
            <td>低</td>
          </tr>
          <tr>
            <td>质量</td>
            <td>化学合成稳定</td>
            <td>批间差大</td>
            <td>内毒素影响大</td>
          </tr>
        </table>
        <p>
          <span class="highLightTexture">sgRNA文库构建：</span>sgRNA文库是指大规模设计并合成的sgRNA集合，通常用于高通量基因筛选或功能研究。通过CRISPR文库筛选，可以系统性地敲除或修饰全基因组范围内的基因，帮助研究人员找出与特定生物学功能或疾病相关的基因。在基因编辑领域，sgRNA文库为精准研究提供了强有力的工具。
        </p>
        <p>
          <span class="highLightTexture">长单链DNA合成（ssDNA）：</span>长单链DNA（ssDNA）作为基因编辑中的修复模板，在同源重组修复（HDR）过程中发挥关键作用。当CRISPR-Cas9诱导双链DNA断裂后，ssDNA模板可提供精确的修复片段，实现特定DNA片段的插入或替换。ssDNA在精准基因编辑和点突变研究中尤其有价值，因其能够提高编辑精度并减少非特异性修复。
        </p>
      </div>

    </section>

    <section class="container">
      <div class="c-title">相关服务<small> Related Services</small></div>
      <ul class="related-services-list flex flex-justify-space-between flex-align-center">
        <li v-for="(item, index) in types" :key="index" class="flex flex-justify-center flex-direction-col flex-align-center"
            @mouseover="currentType = index" @mouseout="currentType = -1"
            @click="jumpPage(item.ref)">
          <div class="service-image flex flex-justify-center flex-align-center">
            <img :src="`/static/images/${item.img}`" :style="item.size">
          </div>

          <p>{{item.name}}</p>
        </li>
      </ul>
    </section>

    <div class="container">
      <qk-consult type="geneEditing"/>
    </div>
  </div>
</template>

<style scoped lang="scss">
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .compose-type1 .neirong{
    display: block!important;
  }
  .effect-lists1{
    flex-wrap: wrap;
    justify-content: flex-start!important;
  }
  .required{
    margin-top: 5px!important;
  }
  .compose-type1{
    padding-bottom: 20px!important;
  }
}
@media screen and (min-width: 641px){
  .effect-lists{
    //display: block!important;
    justify-content: space-between!important;
    flex-wrap:wrap;
    overflow: auto;
      li {
        width: 198px;
        height: 188px;
        &:hover{
          background: #FFFFFF;
          box-shadow: 0px 0px 10px 0px rgba(19,72,157,0.24);
          border-radius: 15px;
        }
      }
  }
}
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title{
  padding-top: 81px;
}
.c-title small{
  margin-top: 10px;
}
.required{
  margin-top: 50px;
  background: none!important;
  margin-left: 0!important;
  font-size: 16px;
}
.desc{
  font-size: 16px;
}

.cons{
  display: none;
}
.texture-body{
  p{
    text-indent: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 29px;
    text-align: justify;
    font-style: normal;
    text-transform: none;
    margin-bottom: 20px;
    &:last-child{
      margin-bottom: 0;
    }
    &.noIndent{
      text-indent: 0;
    }
  }
}

.highLightTexture{
  color: #13489D;
}
.service-process-image{
  img{
    width: 1200px;
  }
}
.case-image{
  margin-top: 50px;
  img {
    width: 1200px;
  }
}
.padding-reset-top{
  padding-top: 0px !important;
}
.service-advantage-bg{
  background: #F6FAFD;
  margin-top: 100px;
}
.service-advantage-content{
  .left {
    padding-bottom: 80px;
    .img-fluid {
      width: 415px; height: 292px;
    }
  }
}
.service-details-table{
  margin-top: 50px;
  margin-bottom: 50px;
  width: 100%;
  border-left: 1px solid #E4E6EA;
  border-top: 1px solid #E4E6EA;
  tr{
    th{
      padding: 20px;
      font-family: PingFangSC, PingFang SC;
      font-size: 16px;
      color: #13489D;
      font-weight: bold;
      line-height: 24px;
      font-style: normal;
      background: #F6FAFD;
      border-bottom: 1px solid #E4E6EA;
      border-right: 1px solid #E4E6EA;
    }
    td{
      padding: 20px;
      padding-left: 30px;
      padding-right: 30px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      font-style: normal;
      text-align: center;
      border-bottom: 1px solid #E4E6EA;
      border-right: 1px solid #E4E6EA;
      &:first-child{
        font-weight: bolder;
      }
    }
  }
}
.related-services-list{
  li{
    transition: all 0.3s;
    cursor: pointer;
    width: 200px;
    height: 200px;
    .service-image {
      width: 105px;
      height: 106px;
    }
    p{
      font-size: 16px;
      line-height: 24px;
      margin-top: 10px;
    }
    &:hover{
      background: #FFFFFF;
      box-shadow: 0px 0px 10px 0px rgba(19,72,157,0.24);
      border-radius: 15px;
    }
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>



// WEBPACK FOOTER //
// src/views/products/Gene_editing.vue